import "./registration-summary.scss";
import { GetRegistrationModel } from "@factory/model/query-model-registration";
import { calendarUtils } from "@shared/utility/calendar-utils/calendar-utils";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

/* eslint-disable-next-line */
export interface RegistrationSummaryProps {
  registration: GetRegistrationModel;
}

export function RegistrationSummary({
  registration,
}: RegistrationSummaryProps) {
  const { formatDateLocal } = useDateTimeContext();

  const summaryFields = [
    { label: "Name", value: calendarUtils.formatClientName(registration) },
    { label: "Service", value: registration.service_name || "N/A" },
    {
      label: "Date & Time",
      value: registration.date
        ? `${formatDateLocal(registration.date)} ${
            registration.time ? `at ${registration.time}` : ""
          }`
        : "N/A",
      condition: !!registration.date,
    },
    { label: "Contact", value: registration.mobile_number || "N/A" },
    { label: "Email", value: registration.email || "N/A" },
    {
      label: "Address",
      value: registration.address,
      condition: !!registration.address,
    },
    {
      label: "Remarks",
      value: registration.other_remarks,
      condition: !!registration.other_remarks,
    },
  ];

  return (
    <div id="RegistrationSummary" className="registration-summary">
      <div className="space-y-4">
        <div className="flex justify-center mb-4">
          <span
            className={`px-3 py-1 rounded-full text-sm font-medium ${calendarUtils.getStatusBadgeClass(
              registration.status || "PENDING"
            )}`}
          >
            {registration.status || "PENDING"}
          </span>
        </div>

        <div className="grid grid-cols-1 gap-3 text-sm">
          {summaryFields.map(
            (field) =>
              field.condition !== false && (
                <div key={field.label}>
                  <label className="font-semibold text-gray-600">
                    {field.label}:
                  </label>
                  <p className="text-gray-900">{field.value}</p>
                </div>
              )
          )}
        </div>
      </div>
    </div>
  );
}

export default RegistrationSummary;
